import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "drv-text-body-md drv-text-weight-medium drv-mb-1" }
const _hoisted_2 = { class: "row drv-gap-4 drv-p-px" }
const _hoisted_3 = { class: "form-item-6" }
const _hoisted_4 = { class: "form-item-6" }

import { computed, ref } from "vue";
import {
  ETelematicsMessagesKeys,
  IPlatform,
  IGeotabBasic,
  EAuthTypes,
  ECommonMessages,
} from "../../../../types";
import { Input } from "draivn-ui-kit/components/input";
import {
  maxLengthValidator,
  minLengthValidator,
  requiredValidator,
} from "draivn-ui-domain";
import HelpLink from "@/modules/onboarding/components/blocks/telematics/HelpLink.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'GeotabBasic',
  props: {
    modelValue: {},
    platform: {},
    disable: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit =
  __emit;

const isDisabled = computed<boolean>(() => {
  return props.disable || isLoading.value;
});

const isLoading = ref(false);

const EMPTY_MODEL = {
  type: EAuthTypes.BASIC,
  username: "",
  password: "",
  database: "",
};

const model = computed<IGeotabBasic>({
  get() {
    return props.modelValue ?? EMPTY_MODEL;
  },
  set(value: IGeotabBasic) {
    emit("update:modelValue", value);
  },
});

const databaseModel = computed<string>({
  get() {
    return props.modelValue?.database ?? EMPTY_MODEL.database;
  },
  set(value: string) {
    model.value = { ...model.value, database: value };
  },
});

const usernameModel = computed<string>({
  get() {
    return props.modelValue?.username ?? EMPTY_MODEL.username;
  },
  set(value: string) {
    model.value = { ...model.value, username: value };
  },
});

const passwordModel = computed<string>({
  get() {
    return props.modelValue?.password ?? EMPTY_MODEL.password;
  },
  set(value: string) {
    model.value = { ...model.value, password: value };
  },
});

const nameControl = ref<typeof Input | null>(null);
const passwordControl = ref<typeof Input | null>(null);

const hasFormError = computed<boolean>(() => {
  return (
    nameControl.value?.hasError ||
    passwordControl.value?.hasError ||
    !usernameModel.value ||
    !passwordModel.value ||
    !databaseModel.value
  );
});

const databaseControl = ref<typeof Input | null>(null);
const hasError = computed<boolean>(() => {
  return (
    hasFormError.value ||
    !databaseModel.value ||
    databaseControl.value?.hasError
  );
});

__expose({
  hasError,
});

return (_ctx: any,_cache: any) => {
  const _component_d_input = _resolveComponent("d-input")!
  const _component_d_password_input = _resolveComponent("d-password-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t(_unref(ETelematicsMessagesKeys).GEOTAB_BASIC_TITLE)), 1),
    _createVNode(HelpLink, {
      link: _ctx.$t(_unref(ETelematicsMessagesKeys).GEOTAB_INSTRUCTIONS_URL)
    }, null, 8, ["link"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_d_input, {
          ref_key: "databaseControl",
          ref: databaseControl,
          class: "drv-form-control-adaptive drv-my-2",
          modelValue: databaseModel.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((databaseModel).value = $event)),
          disable: isDisabled.value,
          label: _ctx.$t(_unref(ETelematicsMessagesKeys).GEOTAB_DATABASE_FIELD_TITLE),
          "lazy-rules": "",
          rules: [
            _unref(requiredValidator)(_ctx.$t(_unref(ECommonMessages).REQUIRED_ERROR)),
            _unref(maxLengthValidator)(
              100,
              _ctx.$t(_unref(ECommonMessages).MAX_LENGTH_ERROR, { length: 100 })
            ),
            _unref(minLengthValidator)(
              2,
              _ctx.$t(_unref(ECommonMessages).MIN_LENGTH_ERROR, { length: 2 })
            ),
          ]
        }, null, 8, ["modelValue", "disable", "label", "rules"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_d_input, {
        ref_key: "nameControl",
        ref: nameControl,
        class: "drv-form-control-adaptive drv-my-2",
        modelValue: usernameModel.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((usernameModel).value = $event)),
        disable: isDisabled.value,
        label: _ctx.$t(_unref(ETelematicsMessagesKeys).GEOTAB_LOGIN_TITLE),
        "lazy-rules": "",
        rules: [
          _unref(requiredValidator)(_ctx.$t(_unref(ECommonMessages).REQUIRED_ERROR)),
          _unref(maxLengthValidator)(
            100,
            _ctx.$t(_unref(ECommonMessages).MAX_LENGTH_ERROR, { length: 100 })
          ),
          _unref(minLengthValidator)(
            2,
            _ctx.$t(_unref(ECommonMessages).MIN_LENGTH_ERROR, { length: 2 })
          ),
        ]
      }, null, 8, ["modelValue", "disable", "label", "rules"]),
      _createVNode(_component_d_password_input, {
        ref_key: "passwordControl",
        ref: passwordControl,
        class: "drv-form-control-adaptive drv-my-2",
        dense: "",
        outlined: "",
        modelValue: passwordModel.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((passwordModel).value = $event)),
        label: _ctx.$t(_unref(ETelematicsMessagesKeys).GEOTAB_PASSWORD_TITLE),
        disable: isDisabled.value,
        "lazy-rules": "",
        rules: [
          _unref(requiredValidator)(_ctx.$t(_unref(ECommonMessages).REQUIRED_ERROR)),
          _unref(maxLengthValidator)(
            100,
            _ctx.$t(_unref(ECommonMessages).MAX_LENGTH_ERROR, { length: 100 })
          ),
          _unref(minLengthValidator)(
            2,
            _ctx.$t(_unref(ECommonMessages).MIN_LENGTH_ERROR, { length: 2 })
          ),
        ]
      }, null, 8, ["modelValue", "label", "disable", "rules"])
    ])
  ]))
}
}

})